import { PropsWithChildren } from 'react';
import { Button, cn } from '@qodo/design-system';
import { ExternalLink as ExternalLinkIcon } from 'lucide-react';
import { openUrl } from '../../utils/url';
import { ExternalLinkProps } from './types';

export const ExternalLink = ({
  url,
  children,
  className,
  iconClassName,
}: PropsWithChildren<ExternalLinkProps>) => (
  <Button
    type="button"
    variant="link"
    className={cn(
      'p-0 h-auto inline text-[length:inherit] group/ext-link',
      className,
    )}
    onClick={() => openUrl(url, true)}
  >
    {children}
    <ExternalLinkIcon
      className={cn(
        'inline align-middle ml-1.5 -translate-y-px stroke-text-action-emphasis-idle group-hover/ext-link:stroke-text-action-emphasis-hover',
        iconClassName,
      )}
      size="16px"
    />
  </Button>
);
